/**
 * DefendantAddressSection - Defendant address fields for AcceptQuoteModal
 */

import { OathInput, OathSelect } from '../../../../shared/OathUI';
import { ACCEPT_QUOTE_FIELD_MAX_LENGTH } from '../../shared/requestFieldLimits';
import { STATE_OPTIONS } from '../../shared/usStates';
import { formatPhoneNumber, unformatPhone } from '../../shared/formatUtils';

const DefendantAddressSection = ({ formState, dispatch, requiredFields }) => {
  const isRequired = (field) => requiredFields.includes(field);
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Defendant Address</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="sm:col-span-2">
          <OathInput
            label="Street"
            maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.defendantStreet}
            value={formState.defendantStreet}
            onChange={set('defendantStreet')}
            placeholder="Street address"
            required={isRequired('defendantStreet')}
          />
        </div>
        <OathInput
          label="City"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.defendantCity}
          value={formState.defendantCity}
          onChange={set('defendantCity')}
          placeholder="City"
          required={isRequired('defendantCity')}
        />
        <OathSelect
          label="State"
          value={formState.defendantState}
          onChange={set('defendantState')}
          options={STATE_OPTIONS}
          placeholder="Select state..."
          required={isRequired('defendantState')}
        />
        <OathInput
          label="Zip Code"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.defendantZipCode}
          value={formState.defendantZipCode}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'defendantZipCode', value: val.replace(/\D/g, '').slice(0, 5) })}
          placeholder="12345"
          required={isRequired('defendantZipCode')}
        />
        <OathInput
          label="Phone"
          value={formatPhoneNumber(formState.defendantPhoneNumber)}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'defendantPhoneNumber', value: unformatPhone(val) })}
          placeholder="(555) 123-4567"
          required={isRequired('defendantPhoneNumber')}
        />
      </div>
    </div>
  );
};

export default DefendantAddressSection;
